import React from 'react';

const Features = () => {
    const features = [
        {
            icon: "🛡️",
            title: "Maximum Security",
            description: "High-grade galvanized steel construction providing impenetrable protection for your property."
        },
        {
            icon: "⚡",
            title: "Smart Automation",
            description: "Advanced motor systems with remote control, app integration, and sensor-based operation."
        },
        {
            icon: "🎨",
            title: "Premium Aesthetics",
            description: "Custom finishes and modern designs that perfectly blend with contemporary architectural styles."
        },
        {
            icon: "🔧",
            title: "24/7 Support",
            description: "Dedicated maintenance team and round-the-clock customer support for complete peace of mind."
        }
    ];

    return (
        <section id="features" className="py-24 bg-dark-800 relative overflow-hidden">
            {/* Background elements */}
            <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none">
                <div className="absolute top-0 right-0 w-96 h-96 bg-royal-500 rounded-full blur-[100px]" />
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-600 rounded-full blur-[100px]" />
            </div>

            <div className="container mx-auto px-6 relative z-10">
                <div className="text-center mb-20 reveal-on-scroll">
                    <h2 className="text-4xl md:text-5xl font-display font-bold mb-6">
                        Why Choose <span className="text-royal-500">Us?</span>
                    </h2>
                    <p className="text-gray-400 max-w-3xl mx-auto text-lg">
                        We don't just build shutters; we engineer peace of mind wrapped in luxury.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="bg-dark-900/50 p-8 rounded-2xl border border-white/5 hover:border-royal-500/30 transition-all duration-300 hover:-translate-y-2 group"
                        >
                            <div className="w-16 h-16 bg-dark-800 rounded-2xl flex items-center justify-center text-4xl mb-6 shadow-inner border border-white/5 group-hover:scale-110 group-hover:bg-royal-900/20 group-hover:border-royal-500/50 transition-all duration-300">
                                {feature.icon}
                            </div>
                            <h3 className="text-xl font-bold text-white mb-4 group-hover:text-royal-500 transition-colors">
                                {feature.title}
                            </h3>
                            <p className="text-gray-400 leading-relaxed text-sm">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Features;
